import Typography from '@mui/material/Typography';

interface StatusChipProps {
  status: string;
  bg: string;
  color: string;
}

export const StatusChip = ({ status, bg, color }: StatusChipProps) => {
  return (
    <Typography
      display="inline"
      color="#12344A"
      variant="body2"
      sx={{
        background: bg,
        color: color,
        fontWeight: 'bold',
        borderRadius: '0.5rem',
        padding: '0.5rem 0.8rem',
      }}
    >
      {status}
    </Typography>
  );
};
